import {parseMetadata, formatObjectKeyValue} from '../argosHistoryTableHelper';

const formatMetadataForExcel = (metadata) => {
    const meta = parseMetadata(metadata);

    if (null === meta) {
        return '';
    }

    return formatObjectKeyValue(meta);
};

export const exportArgosStreamHistoryExcel = (jobId, streamEvents) => ({
    dataExport: streamEvents,
    filename: `argos_job_${jobId}_stream_history`,
    parseData: (entry) => [
        entry.ts || '',
        entry.type || '',
        formatMetadataForExcel(entry.metadata),
    ],
    path: 'events.argosJobs.index.path',
    titles: [
        'Date/time',
        'Event Type',
        'Metadata',
    ],
});
